import Head from 'next/head';
import Link from 'next/link';
import Header from '../../components/Header';

export default function ToiletInstallationPage() {
  const phoneNumber = "(630) 715-8829";
  const companyName = "Partners Plumbing Co.";
  const serviceName = "Toilet Installation & Replacement";
  const serviceArea = "Kane County, Geneva, Saint Charles, South Elgin";

  return (
    <>
      <Head>
        <title>{`Toilet Installation Kane County | Toilet Repair Geneva, IL | ${companyName}`}</title>
        <meta name="description" content={`Toilet installation Kane County & Geneva, IL. Toilet repair, toilet replacement, new toilet installation. Same-day toilet service in St Charles & South Elgin. Call ${phoneNumber} now!`} />
        <meta name="keywords" content="toilet installation Kane County, toilet repair Geneva IL, toilet replacement, toilet installation cost Kane County, toilet repair near me, new toilet installation Geneva" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="canonical" href="https://partnersinplumbing.com/services/toilet-installation" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <div className="min-h-screen bg-white">
        <Header currentPage="/services/toilet-installation" phoneNumber={phoneNumber} companyName={companyName} />

        {/* Sticky Contact Button */}
        <div className="fixed bottom-6 right-6 z-50">
          <Link 
            href="/contact" 
            className="bg-slate-600 text-white px-6 py-3 rounded-full shadow-lg hover:bg-slate-700 transition-colors font-bold text-lg animate-pulse"
          >
            Get Quote
          </Link>
        </div>

        {/* Hero Section */}
        <section className="bg-gradient-to-r from-slate-800 to-slate-900 text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Professional Toilet Installation & Replacement
              </h1>
              <p className="text-xl md:text-2xl text-slate-100 mb-8 max-w-3xl mx-auto">
                Expert toilet installation services in {serviceArea}. Same-day installation available for new toilets and replacements.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
                <a 
                  href={`tel:${phoneNumber}`} 
                  className="bg-yellow-500 text-slate-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-colors"
                >
                  Call Now: {phoneNumber}
                </a>
                <Link 
                  href="/contact" 
                  className="bg-white text-slate-800 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors"
                >
                  Get Free Quote Online
                </Link>
              </div>
              <p className="text-slate-200 text-sm">
                🚽 Same-day installation | 💰 Free estimates | 🔧 All brands serviced
              </p>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Toilet Services</h2>
              <p className="text-xl text-gray-600">Complete toilet installation and replacement solutions</p>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {[
                {
                  title: "New Toilet Installation",
                  description: "Professional installation of new toilets with proper sealing and connections"
                },
                {
                  title: "Toilet Replacement",
                  description: "Complete toilet replacement including removal of old toilet and installation of new unit"
                },
                {
                  title: "Toilet Upgrade",
                  description: "Upgrade to water-efficient or comfort-height toilets for improved performance"
                },
                {
                  title: "Same-Day Service",
                  description: "Quick toilet installation and replacement services available same day"
                },
                {
                  title: "Wax Ring Replacement",
                  description: "Professional wax ring replacement to prevent leaks and odors"
                },
                {
                  title: "Toilet Repair",
                  description: "Complete toilet repair services for running, clogged, or leaking toilets"
                }
              ].map((service, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-lg shadow-md">
                  <h3 className="text-xl font-semibold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-gray-600 mb-4">{service.description}</p>
                  <Link href="/contact" className="bg-yellow-500 text-slate-900 px-6 py-3 rounded-lg font-bold hover:bg-yellow-400 transition-colors inline-block">
                    Get Quote
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-slate-800 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Need a New Toilet Installed?
            </h2>
            <p className="text-xl text-slate-100 mb-8 max-w-3xl mx-auto">
              Our experienced plumbers provide professional toilet installation and replacement services throughout {serviceArea}. Same-day service available. For urgent toilet issues, check our <Link href="/services/emergency-plumbing-service" className="text-yellow-400 hover:text-yellow-300 font-semibold underline">emergency plumber services</Link>.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href={`tel:${phoneNumber}`} 
                className="bg-yellow-500 text-slate-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-colors"
              >
                Call Now: {phoneNumber}
              </a>
              <Link 
                href="/contact" 
                className="bg-white text-slate-800 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors"
              >
                Schedule Service
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
} 